import { render } from "./Bottom.vue?vue&type=template&id=5d0dc1d4&scoped=true"
import script from "./Bottom.vue?vue&type=script&lang=js"
export * from "./Bottom.vue?vue&type=script&lang=js"

import "./Bottom.vue?vue&type=style&index=0&id=5d0dc1d4&lang=css"
import "./Bottom.vue?vue&type=style&index=1&id=5d0dc1d4&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0dc1d4"]])

export default __exports__